export enum EImageStatus {
    Empty = 1, Load , Created , Changed , Saved
}